import { ApplicationConfigurationCustomQuestion } from '@zg-rentals/ts-capps-client';
import type { SupplementalSectionProps } from '../../../../../ApplicationEdit/Sections/7Supplemental/supplementalSections';
import { FINANCIAL_CONTACT_TYPES } from '../../../../../ApplicationEdit/Sections/7Supplemental/ContactQuestions/financialContactTypes';
import { getIsCustomQuestionEnabled } from '../../../../../../utils/customQuestions';
import { hasContactDetails } from '../../../../../../utils/capps-mappers';
import { ContactOverview } from './ContactOverview';

export function FinancialContactsOverview({ answers }: SupplementalSectionProps) {
  const hasBusinessAddress = getIsCustomQuestionEnabled(
    answers,
    ApplicationConfigurationCustomQuestion.FINANCIAL_CONTACTS_BUSINESS_ADDRESS,
  );

  return (
    <>
      {FINANCIAL_CONTACT_TYPES.filter((type) => getIsCustomQuestionEnabled(answers, type.question)).map((type) => {
        const contact = answers[type.fieldName];
        return (
          hasContactDetails(contact) && (
            <ContactOverview
              key={type.fieldName}
              title={type.label}
              contact={contact}
              hasBusinessAddress={hasBusinessAddress}
            />
          )
        );
      })}
    </>
  );
}
